interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  prefilled?: boolean;
}

export function Input({ prefilled, className = '', ...props }: InputProps) {
  const base = 'bg-slate-900 rounded-md px-3 py-2 text-sm text-slate-100 w-full focus:outline-none';
  const border = prefilled
    ? 'border border-blue-700 text-blue-300'
    : 'border border-slate-700 focus:border-blue-500';
  return <input className={`${base} ${border} ${className}`} {...props} />;
}
